import React from "react";
import heroImg from "../../assets/policies/heroImg.webp";

const cookies = [
  {
    type: "Essential Cookies",
    purpose:
      "Enable core site functionality such as navigation, security, and accessibility.",
    examples: "Session ID, authentication cookies",
  },
  {
    type: "Analytics Cookies",
    purpose:
      "Help us understand site usage and performance so we can improve our content.",
    examples: "Google Analytics, heatmap tools",
  },
  {
    type: "Functional Cookies",
    purpose:
      "Remember choices such as language or region to personalize your experience.",
    examples: "Preference cookies",
  },
  {
    type: "Marketing Cookies",
    purpose:
      "Used (if enabled) to measure engagement with campaigns and website interactions.",
    examples: "LinkedIn Insight Tag, Google Ads",
  },
];

const CookiePolicy = () => {
  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-once="true"
      className="relative pt-24 md:pt-32 lg:pt-28 pb-4 md:pb-4 lg:pb-8 
                      px-4 md:px-8 lg:px-12 
                      bg-[#070021] text-white 
                      font-poppins tracking-widest"
    >
      {/* Left Blur  */}
      <div
        className="absolute left-0 top-0 w-[40%] h-[40%] rounded-full 
                           bg-[#1a99c03b] blur-[100px] md:blur-[140px] lg:blur-[180px] 
                           z-0"
      ></div>

      {/* Right Blur */}
      <div
        className="absolute right-0 top-0 w-[45%] h-[45%] rounded-full 
                           bg-[#1a99c03b] blur-[120px] md:blur-[160px] lg:blur-[200px] 
                           z-0"
      ></div>
      <div className="absolute top-0 -right-12 w-[40%]">
        <img
          src={heroImg}
          alt="Hero Background"
          className="inset-0 w-[100%] h-full object-cover "
          loading="eager"
          fetchpriority="high"
        />
      </div>

      <div className="max-w-[95%] mx-auto">
        <h1 className="text-3xl md:text-4xl lg:text-3xl font-semibold mb-8">
          Cookie Policy
        </h1>

        <div className="text-sm md:text-base lg:text-[14px] leading-relaxed mb-1">
          Updated On: <span className="text-[#49D093]">October 2023</span>
        </div>

        <div
          className="h-[0.8px] w-full mb-8 
                      bg-gradient-to-r from-[#49D093] via-[#38b87eef] to-[#0C226E]"
        />

        {/* What Are Cookies */}
        <div data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                       font-medium mb-2 text-[#49D093]"
          >
            What Are Cookies
          </h2>

          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                      font-extralight ml-2 mb-4 leading-relaxed"
          >
            Cookies are small text files stored on your device when you visit
            our website. <br />
            They help us recognize your browser, remember preferences, and
            improve your overall user experience.
          </p>
        </div>

        {/* Types of Cookies We Use */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="100"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                       font-medium mb-2 text-[#49D093]"
          >
            Types of Cookies We Use
          </h2>

          {/* Table Header */}
          <div className="w-auto lg:w-[55%] grid grid-cols-3 gap-2 lg:gap-6 text-[#49D093] text-start text-[11px] md:text-[13px] mb-4 mt-5">
            <p>Type</p>
            <p>Purpose</p>
            <p>Examples</p>
          </div>

          {/* Divider */}
          {/* <div className="w-[55%] h-[1px] bg-white/10 mb-6" /> */}

          {/* Rows */}
          <div className="w-auto lg:w-[55%] space-y-6 text-start mt-6">
            {cookies.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-3 gap-2 lg:gap-6 text-[10px] md:text-[12px] leading-relaxed font-extralight text-white/90"
              >
                <p>{item.type}</p>
                <p>{item.purpose}</p>
                <p>{item.examples}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Managing Cookies */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="200"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                       font-medium mb-2 text-[#49D093]"
          >
            Managing Cookies
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight ml-2 mb-4 leading-relaxed">
            You can choose to accept or decline cookies. Most web browsers
            automatically accept cookies, but you can modify your browser
            settings to decline them. <br />
            Disabling certain cookies may limit some site features.
          </p>
          <p className="text-[10px] md:text-[12px] lg:text-[12px] font-extralight ml-2 mb-4 leading-relaxed">
            If you prefer not to be tracked by analytics cookies, you can opt
            out via your browser or the cookie consent tool on our website.
          </p>
        </div>

        {/* Updates to This Policy */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="300"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                       font-medium mb-2 text-[#49D093]"
          >
            Updates to This Policy
          </h2>
          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            We may revise this Cookie Policy periodically. The latest version
            will always be available on our website. <br />
            For questions or cookie preferences, <br />
            contact us at{" "}
            <span className="text-[#49D093]">privacy@m9-solutions.com</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default CookiePolicy;
